import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import { titleCase } from '../../../../utils/views/pages/Dynamics'
import ImageViewer from './ImageViewer';

const AppInformation = (props) => {
    const app = props.app
    const formDisabled = props.formDisabled
    const setApp = props.setApp
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const validations = props.validations

    let validateField = (e) => {
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        app[e.target.name] = e.target.value
        setApp(app)

    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                App information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6" >
                        <ImageViewer
                            app={app}
                            setApp={setApp}
                            formDisabled={formDisabled}
                        ></ImageViewer>
                    </Col>
                    <Col lg="6">
                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-name"
                                    >
                                        Name
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        defaultValue={app?.name}
                                        id="input-name"
                                        name="name"
                                        placeholder="App Name"
                                        type="text"
                                        disabled={formDisabled}
                                        onChange={handleInput}
                                        required={true}
                                        onBlur={validateField}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-version"
                                    >
                                        Version
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-version"
                                        defaultValue={app?.version}
                                        type="text"
                                        name="version"
                                        placeholder="App Version"
                                        disabled={formDisabled}
                                        onChange={handleInput}
                                        required={true}
                                        onBlur={validateField}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-alias"
                                    >
                                        Alias
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-alias"
                                        defaultValue={app?.alias}
                                        type="text"
                                        name="alias"
                                        placeholder="app-store-alias"
                                        disabled={formDisabled}
                                        onChange={handleInput}
                                        required={true}
                                        onBlur={validateField}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>

                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default AppInformation;